<template>
    <footer class="sticky-footer" :class="footerClass">
        <div class="container my-auto">
            <div class="copyright text-center my-auto">
                <slot></slot>
                <span>Copyright &copy; Gazeto {{year}}. All rights reserved.</span>
            </div>
        </div>
    </footer>
</template>

<script>

export default {
    data() {
        return {
            year: (new Date()).getYear() + 1900
        }
    },
    props: {
        footerClass: [String]
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
</style>